import React from 'react';
import PropTypes from 'prop-types';

import PitchUserActionsDropdown from './PitchUserActionsDropdown';
import Conversation from '../../my_inbox/ConversationsList/Conversation';
import PitchRow from '../../my_inbox/PitchRow';
import PitchBadges from '../../my_inbox/PitchRow/PitchBadges';
import { isFastPitch } from '../../my_inbox/fastPitch';

// One row per PITCH ("follow the inbox"). With a conversation: the REAL
// my_inbox Conversation row. Without: a pitch-centric row borrowing the inbox row's
// utils and markup so the two row types read as one list.
function PitchInboxRail({
  pitches,
  conversationsByPitchId,
  selectedPitchId,
  onSelect,
  onActionComplete,
  requestTitle,
  requestCreatedAt = null,
  muteReport = null,
}) {
  const selectedConversation = conversationsByPitchId[selectedPitchId] || null;

  return (
    <div className="pi-rail my-inbox">
      <div className="pi-rail-title">Pitch Inbox</div>
      <div className="pi-rail-cta">
        <a className="btn btn-secondary w-100" href="/my_inbox_v2" target="_blank" rel="noopener noreferrer">
          View Entire Inbox
        </a>
      </div>
      {pitches.length === 0 && <div className="px-4 py-3 text-secondary small">No pitches here yet.</div>}
      {/* ConversationsList's wrapper: list-group defines the CSS vars the rows' hover/selected states read */}
      <ul className="list-group rounded-0 overflow-x-hidden">
        {pitches.map((pitch) => {
          const conversation = conversationsByPitchId[pitch.id];
          const badges = (
            <PitchBadges
              fast={isFastPitch(pitch.sent_at, requestCreatedAt, pitch.pitch_text)}
              flagged={!!pitch.spam_flagged}
              muted={!!pitch.muted}
              reported={!!pitch.reported}
            />
          );
          if (conversation) {
            return (
              <Conversation
                key={pitch.id}
                conversation={conversation}
                handleClick={() => onSelect(pitch.id)}
                selectedConversation={selectedConversation}
                onActionComplete={onActionComplete}
                titleBadges={badges}
                dropdownOverride={<PitchUserActionsDropdown pitch={pitch} muteReport={muteReport} small />}
              />
            );
          }

          return (
            <PitchRow
              key={pitch.id}
              pitch={pitch}
              selected={pitch.id === selectedPitchId}
              onSelect={() => onSelect(pitch.id)}
              requestTitle={requestTitle}
              requestCreatedAt={requestCreatedAt}
              actions={
                pitch.id === selectedPitchId
                  ? <PitchUserActionsDropdown pitch={pitch} muteReport={muteReport} small />
                  : null
              }
            />
          );
        })}
      </ul>
    </div>
  );
}

PitchInboxRail.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- server-serialized config passed through
  muteReport: PropTypes.object,
  pitches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      profile_name: PropTypes.string,
      profile_image_url: PropTypes.string,
      profile_workplace: PropTypes.string,
      pitch_text: PropTypes.string,
      sent_at: PropTypes.string,
    }),
  ).isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- conversations-view rows passed to my_inbox components verbatim
  conversationsByPitchId: PropTypes.object.isRequired,
  selectedPitchId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  onActionComplete: PropTypes.func.isRequired,
  requestTitle: PropTypes.string,
  requestCreatedAt: PropTypes.string,
};

export default PitchInboxRail;
